<app-wizard-bar *ngIf="wizardMode"></app-wizard-bar>
<router-outlet></router-outlet>
